module.exports = function getResource(label, vars = []) {
    const resources = { min: 'min' };

    return resources[label];
};
